import { render, staticRenderFns } from "./AssignmentPrintInfo.vue?vue&type=template&id=da10e970&scoped=true&"
import script from "./AssignmentPrintInfo.vue?vue&type=script&lang=js&"
export * from "./AssignmentPrintInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPrintInfo.vue?vue&type=style&index=0&id=da10e970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10e970",
  null
  
)

export default component.exports